import React from 'react';
import { Baby, Palette, BookOpen, GraduationCap } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { programs } from '../data/mockData';

const iconMap = {
  Baby: Baby,
  Palette: Palette,
  BookOpen: BookOpen,
  GraduationCap: GraduationCap
};

const ProgramsSection = () => {
  return (
    <section id="programs" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-blue-600">Programs</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Age-appropriate curriculum designed to nurture every stage of development
          </p>
          <div className="w-24 h-1 bg-yellow-400 mx-auto rounded-full mt-4" />
        </div>

        {/* Programs Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 max-w-7xl mx-auto">
          {programs.map((program, index) => {
            const IconComponent = iconMap[program.icon];
            const gradients = [
              'from-blue-500 to-indigo-600',
              'from-yellow-400 to-orange-500',
              'from-green-500 to-emerald-600',
              'from-purple-500 to-pink-600'
            ];
            const gradient = gradients[index % gradients.length];

            return (
              <Card 
                key={program.id} 
                className="border-0 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 group bg-white rounded-3xl overflow-hidden"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Gradient Header */}
                <div className={`h-2 bg-gradient-to-r ${gradient}`}></div>
                
                <CardHeader className="pb-4">
                  <div className={`w-16 h-16 bg-gradient-to-br ${gradient} rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-gray-900 mb-2">
                    {program.title}
                  </CardTitle>
                  <div className={`inline-block bg-gradient-to-r ${gradient} text-white px-4 py-1.5 rounded-full text-sm font-semibold shadow-md`}>
                    {program.ageGroup}
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 leading-relaxed">
                    {program.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;
